module.exports = __webpack_public_path__ + "img/icon-all-ategories.05cece19.png";